import React, {useEffect, useState} from 'react';
import {useNavigate, useParams,} from "react-router-dom";
import MyInput from "../../components/UI/MyInput/MyInput";
import MyButton from "../../components/UI/MyButtons/MyButton";
import Service from "../../API/Service";

const ConstIdPage = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const [updatedData, setUpdatedData] = useState({
        id: "",
        code: "",
        type: "",
        name: "",
        value: "",
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getById(id, "constants");
                const data = response?.data || {};

                setUpdatedData({
                    id: data.id || "",
                    code: data.code || "",
                    type: data.type || "",
                    name: data.name || "",
                    value: data.value || "",
                });

            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    return (
        <div className={"constants__wrap"}>
            <h1>Constants</h1>
            <div className={"content"}>
                <MyInput info={{ name: "Constant code", value: updatedData.code }} isDisabled={true} />
                <MyInput info={{ name: "Constant value", value: updatedData.value }} isDisabled={true} />
                <MyInput info={{ name: "Constant title", value: updatedData.name }} isDisabled={true} />
                <div className={"buttons"}>
                    <MyButton
                        content={"Back"}
                        isBlue={false}
                        onClick={() => navigate(-1)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConstIdPage;